import { getPath } from '@/router/common'

const baseUrl = {
  title: '结款核销',
  path: 'ForPayment'
}

export default [
  {
    path: getPath('ForPayment_Index', baseUrl),
    name: 'ForPayment_ForPayment_Index',
    component: () =>
      import(
        /* webpackChunkName: "ForPayment_ForPayment_Index" */ '@/views/forPayment/forPayment_Index/index.vue'
      ),
    meta: {
      title: '结款核销'
    }
  },
  {
    path: getPath('fsWriteOff', baseUrl),
    name: 'ForPayment_fsWriteOff',
    component: () => import(/* webpackChunkName: "ForPayment_fsWriteOff" */ '@/views/forPayment/fsWriteOff/index.vue'),
    meta: {
      title: '冲销-预付款'
    }
  }
]
